import ready from './ready';

function updateSlider(slider) {
	const holder = slider.parentElement;
	const val = slider.value;
	const numHolder = holder.querySelector('.input-range__number');
	const thumb = holder.querySelector('.input-range__thumb');
	const track = holder.querySelector('.input-range__track');
	const width = holder.getBoundingClientRect().width;
	const thumbWidth = thumb.getBoundingClientRect().width;

	// hard-coding a scale of 0-10 here, so if this range is
	// to change then we'll need to account for it in the below

	// colour the left part of the track
	track.style.backgroundSize = 100 * (val / 10) + '% 100%';

	// Move the pointer
	thumb.style.left = width * (val / 10) - thumbWidth * (val / 10) + 'px';
	numHolder.innerText = val;
}

ready.then(() => {
	let throttle = 0;

	// range
	const rangeSlider = document.querySelector('input.input-range__input');

	// listen for value change
	rangeSlider.addEventListener('input', (event) => {
		updateSlider(event.target);
	});

	// reset the position of the pointer on resize
	window.addEventListener('resize', () => {
		window.clearTimeout(throttle);
		throttle = window.setTimeout(() => {
			updateSlider(rangeSlider);
		}, 100);
	});

	// initialise
	rangeSlider.value = 0;
	updateSlider(rangeSlider);
});
